import React from "react";
import { Text, View } from "react-native";
import { useFormatDate } from "@/elements/hooks/use-format-date";
import { Avatar } from "../ui/avatar";
import RemoteIcon from "@/assets/svgs/remote-icon";
import UserIcon from "@/assets/svgs/user-icon";
import ClockIcon from "@/assets/svgs/clock-icon";

type ConflictSessionData = {
  student: {
    name: string;
    imageUrl?: string;
  };
  subjectName: string;
  deliveryMethod: "in_person" | "remote";
  startTime: number;
  endTime: number;
};

function TutorSessionCardConflict({
  session,
}: {
  session: ConflictSessionData;
}) {
  const fmt = useFormatDate();
  return (
    <View
      className="p-4 rounded-[17px] gap-3 bg-[#FFFDFB] border-2 border-red-500"
      style={{
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        elevation: 2,
      }}
    >
      <View className="flex-row items-center justify-between">
        <View className="flex-row items-center gap-2">
          <Avatar size="sm" className="h-8 w-8">
            <Avatar.Content
              label={session.student.name}
              labelSize="sm"
              size="sm"
              source={
                session.student.imageUrl
                  ? { uri: session.student.imageUrl }
                  : undefined
              }
            />
          </Avatar>
          <Text className="font-geologica-medium font-medium text-base text-gray-800 leading-[1.5]">
            {session.student.name}
          </Text>
        </View>
        <Text className="font-geologica-medium font-medium text-base text-gray-800 leading-[1.2]">
          {fmt(session.startTime, "do MMMM")}
        </Text>
      </View>

      <View className="flex-row items-center justify-between">
        <Text className="font-geologica-regular font-normal text-gray-800 text-sm leading-[1.5]">
          {session.subjectName}
        </Text>

        <View className="flex-row items-center gap-[6px]">
          {session.deliveryMethod === "in_person" ? (
            <UserIcon
              className="size-4"
              pathClassName="stroke-gray-800"
            />
          ) : (
            <RemoteIcon
              className="size-4"
              pathClassName="stroke-gray-800"
            />
          )}
          <Text className="font-geologica-regular font-normal text-gray-800 text-sm leading-[1.5]">
            {session.deliveryMethod === "in_person" ? "In person" : "Remote"}
          </Text>
        </View>

        <View className="flex-row items-center gap-2">
          <ClockIcon
            className="size-4"
            pathClassName="stroke-gray-800"
          />
          <Text className="font-geologica-regular font-normal text-gray-800 text-sm leading-[1.5]">
            {fmt(session.startTime, "HH:mm")} -{" "}
            {fmt(session.endTime, "HH:mm")}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default TutorSessionCardConflict;
